import { Filter } from 'bad-words'
import { env } from '../env'

var filter = null;

const decodeParseValue = (value) => {
    try {
        var words = atob(value);
        return JSON.parse(words);
    } catch (error) {
        console.error('Error parsing JSON:', error.message);
        return null;
    }
}

export const validatePostcode = (value, min, max) => {
    const trimmedValue = value.trim(); //.replace(/\s/g, ''); // Remove spaces
    const length = trimmedValue.length;

    if (length < min || length > max) {
        return false;
    }

    const isValid = /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)?$/.test(trimmedValue);
    return isValid;
};

export const update = (session) => {
    let words = null;

    if (session) {
        if (session.settings && session.settings.bw) {
            words = session.settings.bw;
        } else if (env.VITE_DEFAULT_WORDS) {
            words = env.VITE_DEFAULT_WORDS;
        }

        if (words) {
            const parseWords = decodeParseValue(words);
            if (parseWords) {
                filter = new Filter({ emptyList: true });
                filter.addWords(...parseWords);
            }
        }
    }
}

export const bogusCheck = (text = '') => {
    if (filter && filter.isProfane(text)) {
        console.log('jibble found');
        return false;
    }

    return true;
};
